export default function InputUsername() {
    return {
        restrict: "E",
        scope: {
            form: "=",
            user: "=",
            validation: "=",
            label: "=",
            readonly: "=",
        },
        template: require("./template.html"),

        controller: function ($scope, Users) {
            // $scope.user.username = angular.copy($scope.user.email);

            $scope.checkUniqueUsername = function (username) {
                if (username) {
                    Users.usernameCheck(username).then((res) => {
                        $scope.form.username.$valid = res.isAvailable;

                        // Fallback
                        // if (!res.isAvailable) {
                        //     $scope.form.username;
                        // }
                    }),
                        (err) => {
                            // console.log(err);
                        };
                }
            };

            $scope.checkUniqueUsername($scope.user.username);

            $scope.validationCheck = function () {
                //$scope.form.username.$valid = true;
            };
        },
    };
}
